import { ref } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import useClient from '../client/apiClient'

export default function usePpredios() {

  const ppredio = ref([])
  const ppredio_visita = ref([])
  const origen = ref([])
  const predio = ref([])
  const ppredios = ref([])
  const predios = ref([])
  const bitacora = ref([])
  const visitas = ref([])
  const fscs = ref([])
  const messages = ref([])

  const client = useClient()

  const proveedores = ref([])
  const origenes = ref([])

  const dt = ref(null)
  const loading = ref(false)
  const saving = ref(false)

  const selectedPredios = ref()
  const selectedFscs = ref([]) 
  const selectedCodigoFscs = ref([]) 
  const bitacoraPprediosDialog = ref(false)
  const visitasPprediosDialog = ref(false)
  const deletePpredioDialog = ref(false)
  const deleteVisitaDialog = ref(false)
  const ppredioDialog = ref(false)
  const ppredioVisitaDialog = ref(false)
  const submitted = ref(false)

  const filteredProveedores = ref()
  const filteredOrigenes = ref()
  const filteredPredios = ref()

  const getCRUD = async () => {
    loading.value = true;
    client.get(`/api/ppredios/all/crud`).then(response => {
      // Convertimos fechas a objetos Date
      ppredios.value = response.data.data.ppredios.map(item => {
        const fechaCreacion = new Date(item.created_at).setHours(0, 0, 0, 0); // 🔑 normaliza a medianoche
        
        const codes = (item.fscs || []).map(f => f.pivot?.codigo) .filter(c => c && c !== 'N/A');    

        return {
          ...item,
          fsc_codes: codes.length ? codes.join(', ') : null,
          fsc_codes_array: codes,
          created_at: fechaCreacion,
          updated_at: new Date(item.updated_at)
        };
      });
      proveedores.value = response.data.data.proveedores;
      origenes.value = response.data.data.origenes;
      fscs.value = response.data.data.fscs;
      asignaPrediosProveedor();
      loading.value = false;
    });
  };

  const storePpredio = async (form) => {
    saving.value = true
    let id = ppredio.value.id
    if (id) {
      //Esta editando el registro
      client.put(`/api/ppredios/${id}`, { 'data': { ...form } })
        .then(() => {
          saving.value = !saving.value
          ppredioDialog.value = false
          //client.saving.value = false ?? getCRUD()
          getCRUD()
        })
    } else {
      //Esta creando el registro
      client.post(`/api/ppredios`, { 'data': { ...form } })
        .then(() => {
          ppredioDialog.value = client.dialog.value
          ppredio.value = client.entity.value
          saving.value = client.saving.value
          getCRUD()
        })
    }
  }

  const storeVisita = async (formVisita) => {
    saving.value = true
    //Esta creando el registro
    const fechaStr = formVisita.fecha instanceof Date
      ? formVisita.fecha.toISOString().split("T")[0] // YYYY-MM-DD
      : String(formVisita.fecha).split("T")[0];

    client.post(`/api/ppredios/${formVisita.ppredio?.id || null}/visitas`, {
      'data': {
        fecha: fechaStr,
        comentarios: formVisita.comentarios
      }
    })
      .then(() => {
        ppredioVisitaDialog.value = client.dialog.value
        ppredio.value = client.entity.value
        saving.value = client.saving.value
        getCRUD()
      })
  }

  const deletePpredio = async () => {
    client.remove(`/api/ppredios/${ppredio.value.id}`)
      .then(response => {
        ppredios.value = ppredios.value.filter(val => val.id !== ppredio.value.id)
        deletePpredioDialog.value = false
        ppredio.value = {}
      })
  }

  const deleteVisita = async () => {
    client.remove(`/api/ppredios/${ppredio_visita.value.ppredio_id}/visitas/${ppredio_visita.value.id}`)
      .then(response => {
        visitas.value = visitas.value.filter(
          v => v.id !== ppredio_visita.value.id
        );

        deleteVisitaDialog.value = false; // si usas un diálogo de confirmación
        ppredio_visita.value = {}; // resetear selección
      })
  }

  const filters = ref({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },

    'proveedor.id': { value: null, matchMode: FilterMatchMode.EQUALS },
    'proveedor.rut_dv': { value: null, matchMode: FilterMatchMode.EQUALS },
    'proveedor.razon_social': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'origen._nombre': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'nombre': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'rol': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'fsc_codes': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'volumen_maximo': { value: null, matchMode: FilterMatchMode.EQUALS },
    'volumen_pendiente': { value: null, matchMode: FilterMatchMode.EQUALS },
    'vigente': { value: null, matchMode: FilterMatchMode.EQUALS },
    'created_at': { value: [], matchMode: FilterMatchMode.BETWEEN }, // filtro de fecha
  })

  const asignaPrediosProveedor = () => {
    if (!Array.isArray(proveedores.value) || !Array.isArray(ppredios.value)) return;

    proveedores.value = proveedores.value.map(prov => {
      const provId = Number(prov.id); // blindar tipo
      const prediosDeProveedor = ppredios.value.filter(
        predio => Number(predio.proveedor.id) === provId
      );

      return {
        ...prov,
        predios: prediosDeProveedor
      };
    });
  };

  return {
    ppredio,
    origen,
    predio,
    ppredios,
    origenes,
    predios,
    proveedores,
    fscs,
    dt,
    loading,
    saving,
    filters,
    selectedPredios,
    selectedFscs,
    selectedCodigoFscs,
    bitacora,
    bitacoraPprediosDialog,
    ppredio_visita,
    visitasPprediosDialog,
    visitas,
    deletePpredioDialog,
    ppredioDialog,
    ppredioVisitaDialog,
    submitted,
    filteredProveedores,
    filteredOrigenes,
    filteredPredios,
    messages,
    getCRUD,
    storePpredio,
    storeVisita,
    deletePpredio,
    asignaPrediosProveedor,
    deleteVisitaDialog,
    deleteVisita
  }
}